"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queuesColumns = exports.INTERVAL_RELOAD_QUEUES = exports.limit = void 0;
var i18n_1 = __importDefault(require("@/react-app/i18n"));
exports.limit = 50;
exports.INTERVAL_RELOAD_QUEUES = 3000;
exports.queuesColumns = [
    { label: i18n_1.default.t('MANUAL.QUEUE_LIST_PAGE_BODY.NAME_TITLE'), property: 'nameSort', defaultSort: 'asc' },
    { label: i18n_1.default.t('MANUAL.QUEUE_LIST_PAGE_BODY.PENDING_ITEMS_TITLE'), property: 'count', defaultSort: 'desc' },
    { label: i18n_1.default.t('MANUAL.QUEUE_LIST_PAGE_BODY.LONGEST_WAITING_TITLE'), property: 'oldestSort', defaultSort: 'desc' },
];
